__turbopack_context__.v({
  "backdrop": "yK40Tq_backdrop",
  "body": "yK40Tq_body",
  "close": "yK40Tq_close",
  "footer": "yK40Tq_footer",
  "grabber": "yK40Tq_grabber",
  "header": "yK40Tq_header",
  "popup": "yK40Tq_popup",
  "title": "yK40Tq_title",
});
